import styled from 'styled-components'
import { Flex } from '@nominex/dex-uikit'

export const Row = styled(Flex)<{
  align?: string
  border?: string
  borderRadius?: string
  justify?: string
  padding?: string
  width?: string
}>`
  align-items: ${({ align }) => align ?? 'center'};
  border: ${({ border }) => border};
  border-radius: ${({ borderRadius }) => borderRadius};
  justify-content: ${({ justify }) => justify ?? 'flex-start'};
  padding: ${({ padding }) => padding};
  width: ${({ width }) => width ?? '100%'};
`

export const RowBetween = styled(Row)`
  justify-content: space-between;
`

export const RowFlat = styled(Flex)`
  align-items: flex-end;
`

export const AutoRow = styled(Row)<{ gap?: string }>`
  flex-wrap: wrap;
  margin: ${({ gap }) => gap && `-${gap}`};

  & > * {
    margin: ${({ gap }) => gap} !important;
  }
`

export const RowFixed = styled(Row)<{ gap?: string; justify?: string }>`
  width: fit-content;
  margin: ${({ gap }) => gap && `-${gap}`};
`
